import { render, staticRenderFns } from "./NsAddressForm.vue?vue&type=template&id=0c4e026c&scoped=true&"
import script from "./NsAddressForm.vue?vue&type=script&lang=js&"
export * from "./NsAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressForm.vue?vue&type=style&index=0&lang=scss&module=%24x&"
import style1 from "./NsAddressForm.vue?vue&type=style&index=1&id=0c4e026c&lang=scss&scoped=true&"
import style2 from "./NsAddressForm.vue?vue&type=style&index=2&lang=scss&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c4e026c",
  null
  
)

export default component.exports